/* eslint-disable */
//tslint:disable

export interface IGraphDataSetSchema {
  /** Список точек графика **/
  data: number[];
  /** Регион линии графика **/
  region: ERegion;
}

export enum ERegion {
  /** Ленинградская область **/
  LenObl = 'lenObl',
  /** Московская область **/
  MosObl = 'mosObl',
  /** Москва **/
  Msk = 'msk',
  /** СПб **/
  Spb = 'spb',
}
